import React from "react";

interface Props {
  /** 出错时的兜底 UI；可传节点，或传 (reset) => 节点 以支持重试 */
  fallback: React.ReactNode | ((reset: () => void) => React.ReactNode);
  /** 出错回调（可用于上报） */
  onError?: (error: Error, info: React.ErrorInfo) => void;
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * 通用错误边界：捕获子树渲染期抛出的错误（含 React.lazy 动态加载失败），
 * 展示 fallback，避免整页白屏。
 */
export default class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary] caught:", error, info);
    this.props.onError?.(error, info);
  }

  reset = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      const { fallback } = this.props;
      return typeof fallback === "function" ? fallback(this.reset) : fallback;
    }
    return this.props.children;
  }
}
